import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import { COMMUNITY_ROLE_RESOURCE } from '../../constants';

import apiRoutes from '../../../../app/api/routes';

export default ComposedComponent =>
  reduxFetch([
    {
      resource: COMMUNITY_ROLE_RESOURCE,
      method: 'get',
      request: (communityId, organisationRoleId, t) => ({
        url: apiRoutes.communityRoles2(communityId, organisationRoleId),
        meta: {
          toaster: {
            onErrorMessage: createErrorMessage(t, 'getCommunityRoleFailed'),
          },
        },
      }),
    },
  ])(ComposedComponent);
